<template>
  <div class="df fdc aic jcc">
    <h2 class="nexa-font-bold ttc">
      <span v-if="!$store.getters.afterEmailRecovery">Forgot your password?</span>
      <span v-if="$store.getters.afterEmailRecovery">Reset Request Sent</span>
    </h2>
    <input
      v-if="!$store.getters.afterEmailRecovery"
      v-on:blur="handleBlur"
      v-on:input="setLandingEmail()"
      v-model="email"
      :class="`input-landing input1 mb20 ${showError ? 'error' : ''}`"
      type="email"
      placeholder="Email Address"
    />
    <!-- <button class="button-landing nexa-font-bold ls05"
      v-bind:class="{'disabled-button': disableSubmit}"
      v-on:click="recover()">
      Send Recovery E-mail
    </button> -->
    <p v-if="showError" class="error-message" >Please enter a valid e-mail address</p>
    <div class="message" v-if="$store.getters.afterEmailRecovery">A link has been sent to your email address to reset your password.</div>
    <button v-if="!$store.getters.afterEmailRecovery" class="button-landing nexa-font-bold ls05"
      :disabled="disableSubmit"
      v-on:click="recover()">
      Send Recovery E-mail
    </button>
    <router-link v-if="$store.getters.afterEmailRecovery" to="/login" tag="button" class="button-landing nexa-font-bold ls05">Return to Sign In</router-link>

    <p v-if="!$store.getters.afterEmailRecovery" class="account-caption">Already have an account? <router-link :to="'/login'">Sign in</router-link></p>
    <p v-if="!$store.getters.afterEmailRecovery" class="account-caption mt18">Don't have an account? <router-link :to="'/register'">Sign up</router-link></p>
  </div>
</template>

<script>
export default {
  name: 'ForgotPassword',
  data () {
    return {
      email: '',
      disableSubmit: true,
      showError: false
    }
  },
  props: ['landingEmail'],
  components: {

  },
  methods: {
    validateEmail (mail) {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
        return (true)
      }
      return (false)
    },
    handleBlur() {
      if(!this.validateEmail(this.email) && this.email.length > 0) {
        this.showError = true;
      } else {
        this.showError = false;
      }
    },
    setLandingEmail () {
      console.log('1 Forgot PW')
      this.$emit('setLandingEmail', {landingEmail: this.email})
    },
    recover () {
      this.$store.dispatch('clearAuthError', {
      })
      // if (this.$refs.form.validate()) {
      this.$store.dispatch('forgotPassword', {
        email: this.email
      })
      // }
    },
    recover2 () {
      this.$store.dispatch('clearAuthError', {
      })
      // if (this.$refs.form.validate()) {
      this.$store.dispatch('forgotPassword2', {
        email: this.email,
        url: window.location.origin
      })
      // }
    }
  },
  computed: {

  },
  watch: {
    email() {
      if (this.validateEmail(this.email)) {
        this.disableSubmit = false
        this.showError = false
      } else {
        this.disableSubmit = true
      }
    }
  },
  created () {
    this.landingEmail ? this.email = this.landingEmail : null
    document.onkeydown = checkKey;
    var _this = this
    console.log('** Forgot Password Component Loaded', this.landingEmail)


    this.$store.dispatch('clearAuthError', {})
    function checkKey(e) {
      console.log('enter', e.keyCode == '13')
        e = e || window.event;
        if (e.keyCode == '13') {
          console.log('enter2')
          e.preventDefault()
          _this.recover()
        }
    }
  }
}
</script>

<style scoped lang="scss">
  h2 {
    color: black;
    font-weight: 500;
    margin-bottom: 30px;
    align-self: center;

    // Responsive Style
    // @media max-width: 768px
    @media(max-width: 768px) {
      font-size: 16px;
    }
  }


  .account-caption {
    a {
      color: #5558FF;
      text-decoration: none;
      font-weight: 500;
      cursor: pointer;
    }
  }

  .message {
    width:66%;
    margin: auto;
    padding-bottom: 30px;
    text-align: center;
  }

  .mt18 {
    margin-top: 18px;
  }
  button:disabled, button[disabled] {
  cursor: not-allowed !important;
    background-color: #aca1f4;
  }
  .error-message {
    margin-right: auto;
    margin-bottom: 20px;
    color: red;
    font-size: 14px;
    margin-left: 8px;
  }
  input.error {
    margin-bottom: 5px;
  }
</style>
